import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux'
import { setModal, selectModal } from '../redux/modalSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear, faHistory } from '@fortawesome/free-solid-svg-icons'
import { hasUserPermission } from '../utils/permissionHelper'
import { selectDropdownOptions } from '../redux/dropdownSlice'
import { selectModules } from '../redux/moduleSlice'
import { FormatISODate } from '../helpers/formatting'

export default function PaymentScheduleOptions(props) {
  const { baseName, row, updatePaymentStatus, discountPayment, undiscountPayment, undeferPayment, active, promotionRedeem, loanId, refreshPaymentSchedule, customerLocked, recordChargeback, submitUnlock, revertReschedule } = props
  const dispatch = useDispatch()
  const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options
  const dropdownOptions = useSelector(selectDropdownOptions);
  const paymentStatusPaidId = dropdownOptions.find((o) => o?.code_key === "payment_status_paid")?.id
  const paymentMethodWireId = dropdownOptions.find((o) => o?.code_key === "payment_method_wire_transfer")?.id
  const paymentTypeOriginationId = dropdownOptions.find((o) => o?.code_key === "payment_type_origination")?.id
  const paymentTypeRegularId = dropdownOptions.find((o) => o?.code_key === "payment_type_regular")?.id
  const paymentStatusHoldId = dropdownOptions.find((o) => o?.code_key === "payment_status_hold")?.id
  const paymentStatusScheduledId = dropdownOptions.find((o) => o?.code_key === "payment_status_hold")?.id
  const paymentTypeCreditId = dropdownOptions.find((o) => o?.code_key === "payment_type_credit")?.id
  const modules = useSelector(selectModules)
  const [paymentMethodHelperText, setPaymentMethodHelperText] = useState("");
  const modal = useSelector(selectModal)
  const [disableGear, setDisableGear] = useState(false)

  useEffect(() => {
    if (modules.data.length > 0) {
      const ld = modules.data.find((e) => e.code_key === 'lead')
      if (ld) {
        const ldf = [...ld.module_fields]
        setPaymentMethodHelperText(ldf.find((e) => e.column_name === 'payment_method_dropdown_option_id')?.helper_text)
      }
    }
  }, [modules.data])

  useEffect(() => {
    if (row?.overage_payment_id && row?.payment_type_dropdown_option_id != paymentTypeCreditId) {
      setDisableGear(true)
      return
    }

    if (!row.can_edit && !row.can_revert_reschedule && !(hasUserPermission(activePermissions, 'custom_wire_approval_queue') &&
      row?.payment_status_dropdown_option_id == paymentStatusPaidId &&
      row?.payment_method_dropdown_option_id == paymentMethodWireId &&
      row?.payment_type_dropdown_option_id == paymentTypeOriginationId) && !row.can_discount && !row.can_undefer && !row.can_undiscount && !(hasUserPermission(activePermissions, 'payment_quick_action_chargeback') && row?.can_record_chargeback !== undefined && row?.can_record_chargeback == true) && process.env.REACT_APP_ENVIRONMENT === 'production' &&
      !(row?.payment_status_dropdown_option_id == paymentStatusHoldId)) {
      setDisableGear(true)
    } else {
      setDisableGear(false)
    }
  }, [row, activePermissions])

  /**
 * On Click Handler to display the History Modal (Drawer)
 */
  const slideDownHistory = (paymentId) => {
    if (modal.is_active === false) {
      dispatch(
        // add here
        setModal({ is_active: true, title: `Payment History`, content: `${process.env.REACT_APP_API_DOMAIN}/payment/${paymentId}/payment_audit`, type: 'history', parent_modal: `payment` })
      )
    } else {
      dispatch(setModal({ title: `Payment History`, content: '', type: '', is_active: false }))
    }
  }

  const handleEditPaymentClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'payment_schedule_edit_payment_modal',
        options: {
          loanId: loanId,
          paymentId: row.id,
          successCallback: () => refreshPaymentSchedule(),
          paymentMethodHelperText: paymentMethodHelperText
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleRevertRescheduleClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Revert Reschedule",
          description: "Are you sure you want to revert this payment to the original scheduled date of " + FormatISODate(row.original_scheduled_date) + "?",
          actionLabel: "Yes",
          callMethod: () => { revertReschedule(row.id) }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsPaidClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Mark as Paid",
          description: "Are you sure to mark this payment as paid of payment id " + row.id + "?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_paid') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsInQueueClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Mark as In Queue",
          description: "Are you sure to mark this payment as In Queue of payment id " + row.id + "?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_in_queue') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsInProcessClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Mark as In Process",
          description: "Are you sure to mark this payment as In Process of payment id " + row.id + "?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_in_process') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsReturnedClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Mark as Returned",
          description: "Are you sure to mark this payment as returned of payment id " + row.id + "?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_returned') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsMissedClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Mark as Missed",
          description: "Are you sure to mark this payment as missed of payment id " + row.id + "?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_missed') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsErrorClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Mark as Error",
          description: "Are you sure to mark this payment as error of payment id " + row.id + "?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_error') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleReturnToScheduledStateClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Return to Scheduled State",
          description: "Are you sure to return payment id " + row.id + " to scheduled state?",
          actionLabel: "Yes",
          callMethod: () => { updatePaymentStatus(row.id, 'payment_status_scheduled') }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleMarkAsScheduledClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'unhold_payment_modal',
        options: {
          payment_id: row.id,
          loan_id: loanId,
          successCallback: () => refreshPaymentSchedule(),
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleRemoveDiscountClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Remove Discount",
          description: "Are you sure to remove discount?",
          actionLabel: "Yes",
          callMethod: () => { undiscountPayment(row.id) }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleRemoveDeferralClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Remove Deferral",
          description: "Are you sure to remove deferral?",
          actionLabel: "Yes",
          callMethod: () => { undeferPayment(row.id) }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleRecordChargebackClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'are_you_sure',
        options: {
          title: "Record Chargeback",
          description: "Are you sure to record chargeback?",
          actionLabel: "Yes",
          callMethod: () => { recordChargeback(row.id) }
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleAddDiscountClick = (event) => {
    const isDisabled = row?.can_discount === false && row?.can_discount !== undefined;
    if (isDisabled) {
      event.preventDefault();
    } else {
      discountPayment(row.id)
    }
    submitUnlock(1)
    handleClick()
  }

  const [isActive, setIsActive] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const node = useRef();
  const triggerRef = useRef();
  const menuRef = useRef();

  const handleClick = () => {
    setIsActive(!isActive);
  }

  const handleClickOutside = (event) => {
    if (node.current?.contains(event.target)) return;
    if (menuRef.current?.contains(event.target)) return;
    setIsActive(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isActive || !triggerRef.current) return;
    const updatePos = () => {
      const rect = triggerRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.top + window.scrollY,
        left: rect.right + window.scrollX,
      });
    };
    updatePos();
    window.addEventListener('resize', updatePos);
    window.addEventListener('scroll', updatePos, true);
    return () => {
      window.removeEventListener('resize', updatePos);
      window.removeEventListener('scroll', updatePos, true);
    };
  }, [isActive]);

  return (
    <>
      <div className={`dropdown is-up is-right ${isActive ? 'is-active' : ''} control mr-1`} ref={node}>
        <div className="dropdown-trigger">
          <button
            ref={triggerRef}
            type="button"
            data-testid={`payment-row-${row.id}-cog`}
            className={`button has-text-white has-background-grey`}
            onClick={handleClick}
            disabled={customerLocked || disableGear}
          >
            <FontAwesomeIcon icon={faGear} />
          </button>
        </div>
      </div>
      {isActive && createPortal(
        <div
          ref={menuRef}
          className="dropdown-menu has-text-left"
          id="dropdown-menu"
          role="menu"
          style={{
            display: 'block',
            position: 'absolute',
            top: menuPos.top,
            left: menuPos.left,
            transform: 'translate(-100%, -100%)',
          }}
        >
          <div className="dropdown-content">
            {row?.can_edit !== undefined && row?.can_edit === true && (
              <a
                data-testid={`payment-row-${row.id}-edit`}
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleEditPaymentClick}
              >
                Edit Payment
              </a>
            )}
            {row?.can_revert_reschedule !== undefined && row?.can_revert_reschedule === true && (
              <a
                data-testid={`payment-row-${row.id}-revert-reschedule`}
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleRevertRescheduleClick}
              >
                Revert Reschedule
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsInQueueClick}
              >
                TEST ONLY - Mark as In Queue
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsInProcessClick}
              >
                TEST ONLY - Mark as In Process
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsPaidClick}
              >
                TEST ONLY - Mark as Paid
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                data-testid={`payment-row-${row.id}-mark-returned`}
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsReturnedClick}
              >
                TEST ONLY - Mark as Returned
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsMissedClick}
              >
                TEST ONLY - Mark as Missed
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsErrorClick}
              >
                TEST ONLY - Mark as Error
              </a>
            )}
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleReturnToScheduledStateClick}
              >
                TEST ONLY - Return to Scheduled State
              </a>
            )}
            {row?.payment_status_dropdown_option_id == paymentStatusHoldId && row?.can_unhold && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleMarkAsScheduledClick}
              >
                Unhold Payment
              </a>
            )}
            {hasUserPermission(activePermissions, 'custom_wire_approval_queue') &&
              row?.payment_status_dropdown_option_id == paymentStatusPaidId &&
              row?.payment_method_dropdown_option_id == paymentMethodWireId &&
              row?.payment_type_dropdown_option_id == paymentTypeOriginationId &&
              (
                <a
                  className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                  onClick={handleMarkAsReturnedClick}
                >
                  Mark Wire Returned
                </a>
              )}
            {row?.can_discount !== undefined && row?.can_discount == true && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleAddDiscountClick}
              >
                Add Discount
              </a>
            )}
            {row?.can_undiscount !== undefined && row?.can_undiscount == true && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleRemoveDiscountClick}
              >
                Remove Discount
              </a>
            )}
            {row?.can_undefer !== undefined && row?.can_undefer == true && (
              <a
                data-testid={`payment-row-${row.id}-remove-deferral`}
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleRemoveDeferralClick}
              >
                Remove Deferral
              </a>
            )}
            {hasUserPermission(activePermissions, 'payment_quick_action_chargeback') && row?.can_record_chargeback !== undefined && row?.can_record_chargeback == true && (
              <a
                className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
                onClick={handleRecordChargebackClick}
              >
                Record Chargeback
              </a>
            )}
          </div>
        </div>,
        document.body
      )}
      <button
        type="button"
        key={`history-drawer-${row.id}`}
        className="button has-background-grey has-text-white mr-1"
        onClick={() => { slideDownHistory(row.id); }}
      >
        <FontAwesomeIcon icon={faHistory} />
      </button>
    </>
  )
}
